import { Stack } from '@mui/system';
import { CSSProperties, useMemo } from 'react';
import NamedValue from '../NamedValue';
import DialogZoomField from './DialogZoomField';

const credentialReplacer = (key: string, value: string) => {
  if (key.startsWith('auth') || key.endsWith('Token') || key.endsWith('Password') || key.endsWith('Secret')) {
    return '*';
  }

  return value;
};

interface Props {
  json: Record<string, unknown>;
  expandedTitle: React.ReactNode;
  headline?: Record<string, string>;
  headlineColorMap?: Record<string, (value: string) => CSSProperties['color'] | undefined>;
}

export default function RawJsonField({ json, headline, headlineColorMap, expandedTitle }: Props): React.JSX.Element {
  const headlineElement = useMemo(() => {
    const entries = Object.entries(headline ?? {}).map((entry, idx) => {
      const [key, value] = entry;
      let valueColor = undefined;
      if (headlineColorMap && headlineColorMap[key]) {
        valueColor = headlineColorMap[key](value);
      }

      return <NamedValue key={idx} name={key} value={value} direction={'row'} valueColor={valueColor} />;
    });
    return (
      <Stack direction={'column'} justifyContent={'center'}>
        {entries}
      </Stack>
    );
  }, [headline, headlineColorMap, json]);

  const fullElement = useMemo(() => <pre>{JSON.stringify(json, credentialReplacer, 2)}</pre>, [json]);

  return (
    <DialogZoomField title={expandedTitle} content={fullElement} placement={'end'}>
      {headlineElement}
    </DialogZoomField>
  );
}
